// Theme-Manager
import { apiCall } from '../utils/api.js';

export const themeManager = {
	init() {
		// Theme aus Body-Attribut lesen (wurde server-seitig gesetzt)
		const currentTheme = document.body.getAttribute('data-theme') || 'normal';

		// LocalStorage synchronisieren
		localStorage.setItem('theme', currentTheme);

		// aria-pressed initial setzen (falls JavaScript vor PHP läuft)
		const toggleButton = document.querySelector('[data-theme-toggle]');
		if (toggleButton) {
			toggleButton.setAttribute('aria-pressed', currentTheme === 'high-contrast' ? 'true' : 'false');
		}
	},

	async toggle() {
		const currentTheme = document.body.getAttribute('data-theme') || 'normal';
		const newTheme = currentTheme === 'normal' ? 'high-contrast' : 'normal';

		// Sofortiges UI-Update
		document.body.setAttribute('data-theme', newTheme);
		localStorage.setItem('theme', newTheme);

		// aria-pressed für Screenreader aktualisieren
		const toggleButton = document.querySelector('[data-theme-toggle]');
		if (toggleButton) {
			toggleButton.setAttribute('aria-pressed', newTheme === 'high-contrast' ? 'true' : 'false');
		}

		// Server-seitig speichern
		try {
			await apiCall('theme-toggle', {
				method: 'POST',
				body: `theme=${newTheme}`
			});
		} catch (error) {
			console.warn('Theme konnte nicht in Session gespeichert werden:', error);
		}
	}
};

// Event-Listener-Registrierung
export function initThemeToggle() {
	themeManager.init();

	document.addEventListener('DOMContentLoaded', () => {
		const toggleButton = document.querySelector('[data-theme-toggle]');
		if (toggleButton) {
			// Click-Event für Mausklicks
			toggleButton.addEventListener('click', (e) => {
				e.preventDefault();
				themeManager.toggle();
			});
		}
	});
}
